module.exports = __webpack_public_path__ + "img/sndle-avatar-female.d658059b.png";